import {MutationTree} from "vuex";
import {v4 as uuid} from 'uuid';
import IMessage from "@/modules/Chat/ts/IMessage";
import IUser from "@/modules/UserManager/ts/IUser";
import moment from 'moment';

export const mutations: MutationTree<any> = {

    /**
     * Team messages
     *
     * @param state
     * @param payload
     */
    addTeamMessage(state: any, payload: IMessage) {

        state.teamMessages.push({
            'id': uuid(),
            'message': payload.message,
            'user': payload.user,
            'created_at': moment().format('YYYY-MM-DD HH:mm:ss'),
            'seen': false,
        });

        // Remove any message older than 7 days
        state.teamMessages = state.teamMessages.filter((message: IMessage) => {
            return !moment(message.created_at).isBefore(moment().subtract(7, 'days'))
        });

        localStorage.setItem('teamMessages', JSON.stringify(state.teamMessages));
    },

    /**
     * Mark team message seen
     *
     * @param state
     */
    markTeamMessagesSeen(state: any) {
        state.teamMessages.forEach((message: IMessage) => {
            message.seen = true;
        });

        const lastIndex = state.teamMessages.length;
        let startIndex = lastIndex - 100;
        if (startIndex < 0) startIndex = 0;

        localStorage.setItem('teamMessages', JSON.stringify(state.teamMessages.slice(startIndex,lastIndex)));
    },

    /**
     * Set team messages from localStorage
     *
     * @param state
     * @param payload
     */
    initializeTeamMessages(state: any, payload: Array<IMessage>) {
        const messages = localStorage.getItem('teamMessages');

        if (messages) {
            state.teamMessages = JSON.parse(messages);
        }
    },

    /**
     * Set active chat user from the presence channel
     *
     * @param state
     * @param users
     */
    setChatUsers(state: any, users: Array<IUser>) {
        state.chatUsers = users;
    },

    /**
     * Add chat user
     *
     * @param state
     * @param user
     */
    addChatUser(state: any, user: IUser) {
        const found = state.chatUsers.find((chatUser: IUser) => {
            return chatUser.id === user.id
        });

        if (!found) state.chatUsers.push(user);
    },

    /**
     * Remove chat user
     *
     * @param state
     * @param user
     */
    removeChatUser(state: any, user: IUser) {
        const index = state.chatUsers.findIndex((chatUser: IUser) => {
            return chatUser.id === user.id
        });

        state.chatUsers.splice(index, 1);
    },

    /**
     * Add private message
     * @param state
     * @param payload
     */

    addPrivateMessage(state: any, payload: any) {

        const key = 'user_' + payload.receiver;

        if (!state.privateMessages.hasOwnProperty(key)) {
            payload.set(state.privateMessages, key, []);
        }

        const message = {
            'id': uuid(),
            'message': payload.message,
            'user': payload.user,
            'created_at': moment().format('YYYY-MM-DD HH:mm:ss'),
            'seen': false,
        };

        state.privateMessages[key].push(message);

        // Remove any message older than 31 days
        state.privateMessages[key] = state.privateMessages[key].filter((message: IMessage) => {
            return !moment(message.created_at).isBefore(moment().subtract(31, 'days'))
        });

        localStorage.setItem('privateMessages', JSON.stringify(state.privateMessages));
    },

    /**
     * Set private message seen. This is execute when user opens the message box
     * @param state
     * @param user
     */
    setPrivateMessagesSeen(state: any, user: IUser) {

        const key = "user_" + user.id;

        if (state.privateMessages.hasOwnProperty(key)) {
            state.privateMessages[key].forEach((message: IMessage) => message.seen = true);
            localStorage.setItem('privateMessages', JSON.stringify(state.privateMessages));
        }
    },

    /**
     * Load messages from the local storage
     *
     * @param state
     */
    initializePrivateMessages(state: any) {

        const messages = localStorage.getItem('privateMessages');

        if (messages) {
            state.privateMessages = JSON.parse(messages);
        }
    }
}
